import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

export const BackToLobby = ({ to, testId }) => {
  const { t } = useI18n();
  return (
    <Link to={to} className="inline-flex h-10 items-center gap-1.5 rounded-full border border-white/15 bg-white/5 px-4 text-sm font-semibold text-slate-100 transition-colors hover:bg-white/10" data-testid={testId}>
      <ArrowLeft className="h-4 w-4" /> {t("common.back")}
    </Link>
  );
};
